import { HeaderBar } from '@fortem-monorepo/react-spa'

import { LayoutOutlet } from '@/components/LayoutOutlet'
import { NavigationTabs, NavigationTabsList } from '@/components/NavigationTabs'
import { MONITORING_LINKS } from '@/constants/links'

export interface MonitoringLayoutProps {}

export const MonitoringLayout: React.FC<MonitoringLayoutProps> = ({}) => {
  return (
    <>
      <HeaderBar>
        <NavigationTabs>
          <NavigationTabsList links={MONITORING_LINKS} />
        </NavigationTabs>
      </HeaderBar>
      <LayoutOutlet />
    </>
  )
}
